import React from 'react'
import { parse } from '@wordpress/block-serialization-default-parser'
import Fade from 'react-reveal/Fade'
import Image from '../Image'
import VideoPlayer from '../VideoPlayer'
import ReactHtmlParser from 'react-html-parser';
import { StWordpressRaw, CoreColumns, CoreColumnBlock } from './style.css'
import GetVideo from './Getvideo'

const WordpressRawContent = ( {raw} ) => {
  const parsedContent = parse(raw)

  return (
    <StWordpressRaw>
      {
        parsedContent.map((block, index) => {

          if(typeof block.blockName === 'object' && block.blockName === null)
            return null

          if (block.blockName === 'core/image') {
            const parsedhtml = ReactHtmlParser(block.innerHTML)

            if(parsedhtml[0].type === 'figure'){
              const figure = parsedhtml[0]
              const figcaption = figure.props.children.filter(element => element.type === 'figcaption' )
              console.log('figure 1', figure.props.children[0].props.src)
              return (

                  <figure key={index}>
                    <Image originalurl={figure.props.children[0].props.src} />
                    {
                      figcaption.length > 0 && (
                        <figcaption className="figwrap">{figcaption}</figcaption>
                      )
                    }
                  </figure>

              )
            }

            // return (

            //     // <WpImageToLocal key={index} wordpressid={block.attrs.id} />

            // )
          }

          if (block.blockName === 'core/quote') {
            return (
              <Fade key={index}>
                <quote dangerouslySetInnerHTML={{ __html: block.innerHTML }} />
              </Fade>
            )
          }

          if (block.blockName === 'core/list') {
            return (
              <Fade key={index}>
                <div dangerouslySetInnerHTML={{ __html: block.innerHTML }} />
              </Fade>
            )
          }

          if (block.blockName === 'core/verse') {
            return (
              <Fade key={index}>
                <div dangerouslySetInnerHTML={{ __html: block.innerHTML }} />
              </Fade>
            )
          }

          if (block.blockName === 'core/video') {
            const parsedhtml = ReactHtmlParser(block.innerHTML)
            if (parsedhtml[0].type === 'figure') {
              const figure = parsedhtml[0]
              if(figure.props.children){
                if(figure.props.children[0]){
                  const srcurl = figure.props.children[0].props.src
                  const filename = srcurl.substring(srcurl.lastIndexOf('/')+1)
                  return (
                    <Fade key={index}>
                      <div>
                        <GetVideo filename={filename} noProportions controls={false} />
                      </div>
                    </Fade>
                  )
                }
              }
            }
          }

          if (block.blockName === 'core/media-text' && block.attrs.mediaType === 'image') {

            try {
              const parsedhtml = ReactHtmlParser(block.innerHTML)

              if(parsedhtml[0].props.children[0].props.children[0].props.src){

                const srcurl = parsedhtml[0].props.children[0].props.children[0].props.src
                const filename = srcurl.substring(srcurl.lastIndexOf('/')+1)

                return (

                    <div key={index}>
                      <div className="col col1">
                        <Image filename={filename} />
                      </div>
                      <div className="col col2">
                        {
                          block.innerBlocks.map((childblock, ind) => {
                            const replacedhtml = childblock.innerHTML.replace('data-tooltip', 'data-tip')
                            return (
                              <div key={ind} className="coreParagraph" dangerouslySetInnerHTML={{ __html: replacedhtml }} />
                            )
                          })
                        }
                      </div>
                    </div>

                )
              }
            } catch (err) {console.log(err)}
          }

            if(block.blockName === 'core/media-text' &&  block.attrs.mediaType === 'video'){

              const parsedhtml = ReactHtmlParser(block.innerHTML)

              if (parsedhtml[0].type === 'div') {
                const div = parsedhtml[0]
                if(div.props.children){
                  if(div.props.children[0]){
                    const srcurl = div.props.children[0].props.children[0].props.src
                    const filename = srcurl.substring(srcurl.lastIndexOf('/')+1)

                    return (

                        <div key={index}>
                          <div className="col col1">
                            <GetVideo filename={filename} noProportions controls={false} />
                          </div>
                          <div className="col col2">
                            {
                              block.innerBlocks.map((childblock, ind) => {
                                const replacedhtml = childblock.innerHTML.replace('data-tooltip', 'data-tip')
                                return (
                                  <div key={ind} className="coreParagraph" dangerouslySetInnerHTML={{ __html: replacedhtml }} />
                                )
                              })
                            }
                          </div>
                        </div>

                    )
                  }
                }
              }
            }

          if (block.blockName === 'core/heading') {
            return (
              <Fade key={index}>
                <div className="coreParagraph" dangerouslySetInnerHTML={{ __html: block.innerHTML }} />
              </Fade>
            )
          }

          if(block.blockName === 'core/columns') {
            const columns = block.innerBlocks
            return (
              <CoreColumns key={index} gridtemplatecolumns={`1fr 3fr`}>
                {
                  columns.map((column, colindex) => {
                    const innerBlocks = column.innerBlocks
                    return (
                      <div className="col" key={colindex}>
                        {

                          innerBlocks.map((innerBlock, innerBlockIndex) => {
                            console.log(innerBlock)
                            return (
                              <Fade key={innerBlockIndex}>
                                {
                                  innerBlock.blockName === 'core/image' ? (
                                    <figure>
                                      <h2>hola</h2>
                                      {/* <WpImageToLocal wordpressid={innerBlock.attrs.id} /> */}
                                    </figure>
                                  ) : (
                                    <CoreColumnBlock dangerouslySetInnerHTML={{ __html: innerBlock.innerHTML }} />
                                  )
                                }
                              </Fade>
                            )
                          })
                        }
                      </div>
                    )
                  })
                }
              </CoreColumns>
            )
          }


          if (block.blockName === 'core/paragraph') {
            const replacedhtml = block.innerHTML.replace('data-tooltip', 'data-tip')
            return (
              <Fade key={index}>
                <div className="coreParagraph" dangerouslySetInnerHTML={{ __html: replacedhtml }} />
              </Fade>
            )
          } else {
            console.log('block', block)
            return null
          }
        })
      }
    </StWordpressRaw>
  )
}

export default WordpressRawContent